export const defaultSearchFormColumns = () => {
  return [
    {
      name: '客户编码',
      prop: 'customerName',
      type: 'input',
      disabled: true,
    },
    {
      name: '业务日期从',
      prop: 'businessDateStart',
      type: 'startDaterangePicker',
      disabled: true,
    },
    {
      name: '业务日期至',
      prop: 'businessDateEnd',
      type: 'endDaterangePicker',
      disabled: true,
    },
    {
      name: '入库日期从',
      prop: 'inboundDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '入库日期至',
      prop: 'inboundDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '出库日期从',
      prop: 'outboundDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '出库日期至',
      prop: 'outboundDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '日期从',
      prop: 'createDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '日期至',
      prop: 'createDateEnd',
      type: 'endDaterangePicker',
    },
  ];
};

export const defaultColumnList = () => {
  return [
    // {
    //   field: 'index',
    //   title: '序号',
    // },
    // {
    //   type: 'checkbox',
    //   visible: true,
    //   width: '50',
    //   fixed: 'left',
    // },
    {
      field: 'customerName',
      title: '客户名称',
    },
    {
      field: 'docNo',
      title: '单号',
    },
    {
      field: 'wagonNo',
      title: '车皮号',
    },
    {
      field: 'inboundDate',
      title: '入库日期',
    },
    {
      field: 'outboundDate',
      title: '出库日期',
    },
    {
      field: 'storageDay',
      title: '仓储天数',
    },
    {
      field: 'goodsName',
      title: '货物名称',
    },
    {
      field: 'material',
      title: '材质',
    },
    {
      field: 'spec',
      title: '中文规格',
    },
    {
      field: 'steelCoilNo',
      title: '钢卷号',
    },
    {
      field: 'goodsLocation',
      title: '货位',
    },
    {
      field: 'weight',
      title: '重量',
    },
    {
      field: 'price',
      title: '单价（元/吨）',
    },
    {
      field: 'amount',
      title: '金额',
    },
    {
      field: 'remark',
      title: '备注',
    },
  ];
};
